/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown> }} Sales_Return_Return_AllInputs */

const vi_sales_return_return_all = /** @type {(inputs: Sales_Return_Return_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trả hết (${i?.qty})`)
};

/**

* @param {Sales_Return_Return_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_return_all = /** @type {((inputs: Sales_Return_Return_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Return_AllInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_return_all(inputs)
});